// moment.js
// version : 2.18.1
// authors : Tim Wood, Iskren Chernev, Moment.js contributors
// license : MIT
// momentjs.com
import { formatFunctions, makeFormatFunction } from './format-functions';
import './locale';
import { getLocale } from './locale/locales.service';
import './units';
import { isDateValid } from './utils/type-checks';
export function formatDate(date, format, locale) {
    if (locale === void 0) { locale = 'en'; }
    var _locale = getLocale(locale);
    var output = formatMoment(date, format, _locale);
    return _locale.postformat(output);
}
// format date using native date object
export function formatMoment(date, format, locale) {
    if (!isDateValid(date)) {
        return locale.invalidDate;
    }
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](date, locale);
}
//# sourceMappingURL=format.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/format.js
// module id = 847
// module chunks = 103